import * as o from "react";
import r from "../lib/IconBase.es.js";
import n from "../defs/RadioButton.es.js";
const t = o.forwardRef((a, e) => /* @__PURE__ */ o.createElement(r, { ref: e, ...a, weights: n }));
t.displayName = "RadioButtonIcon";
const c = t;
export {
  c as RadioButton,
  t as RadioButtonIcon
};
